module.exports = MaterialUI.Badge;